class SliderSwitcher {
    constructor ($switch) {
        this.$switch = $switch;
        this.$accessoriesMarker = $switch.querySelector('[data-marker]');
        this.receivedData = null;
        this.dataCollection = {};
        this.isLoading = false;
        this.init();
    }

    init () {
        this.bindEvents();
    }

    bindEvents () {
        const $selector = this.$switch;
        const selectorEvent = ($selectorItem) => {
            // execute all functions on slider switch click
            $selectorItem.addEventListener('click', (e) => {
                e.preventDefault();

                if (this.isLoading === false) {
                    const itemName = $selectorItem.getAttribute('data-switch-item');

                    // fire click before ajax
                    this.triggerSwitchedEvent();

                    // change switch states
                    this.moveMarker($selectorItem);
                    this.handleActiveClass($selector, $selectorItem);
                    // make ajax
                    this.handleAjax(itemName);
                } else {
                    console.warn('still loading ...');
                }
            });
        };

        if ($selector) {
            const $accessories = $selector.querySelectorAll('[data-switch-item]');
            const $activeSelector = $selector.querySelectorAll('[data-switch-item].slider-switch__link--active');

            this.moveMarker($activeSelector[0]);

            for (let i = 0; i < $accessories.length; i++) {
                selectorEvent($accessories[i]);
            }
        }

        document.addEventListener('design_m', () => {
            this.moveMarker($selector.querySelector('[data-switch-item].slider-switch__link--active'));
        });

        document.addEventListener('design_s', () => {
            this.moveMarker($selector.querySelector('[data-switch-item].slider-switch__link--active'));
        });
    }

    // removes and adds
    handleActiveClass = ($selector, $accessoriesSelectorItem) => {
        $selector.querySelector('[data-switch-item].slider-switch__link--active').classList.remove('slider-switch__link--active');
        $accessoriesSelectorItem.classList.add('slider-switch__link--active');
    };

    moveMarker = ($activeElement) => {
        this.$accessoriesMarker.style.width = $activeElement.scrollWidth + 'px';
        this.$accessoriesMarker.style.left = $activeElement.parentNode.offsetLeft + 'px';
    };

    handleAjax = (itemName) => {
        const url = this.$switch.getAttribute('data-switch-url') + itemName + '/';
        const request = new XMLHttpRequest();
        request.open('GET', url, true);
        request.send();
        this.isLoading = true;

        request.addEventListener('load', (e) => {
            const receivedData = JSON.parse(e.target.response);

            // handle active slide and background image after
            // ajax load is done
            this.dataCollection[itemName] = receivedData;
            this.receivedData = receivedData;
            this.triggerDataReadyEvent();
            this.isLoading = false;
        });

        request.addEventListener('error', (e) => {
            this.receivedData = false;
            this.triggerDataReadyEvent();
            this.isLoading = false;
        });
    };

    triggerSwitchedEvent = () => {
        const switchEvent = new CustomEvent('switched', {
            view: window,
            bubbles: true,
            cancelable: false
        });

        this.$switch.dispatchEvent(switchEvent);
    };

    triggerDataReadyEvent = () => {
        const dataReadyEvent = new CustomEvent('dataReady', {
            view: window,
            bubbles: true,
            cancelable: false
        });

        this.$switch.dispatchEvent(dataReadyEvent);
    };
}

export { SliderSwitcher };
